export default __webpack_public_path__ + "static/media/insufficient_balance.2ab444c0.svg";